import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { TemplateTypes } from '@lbmx/per-form-primeng';
import { LockService } from '@lbmx/root-services';
import { Request } from '@lbmx/web-core';
import { ConfigProvider } from 'src/app/provider/config-provider';
import { ComponentCanDeactivate } from '../../../automations-module/shared/reload/component-can-deactivate';

@Component({
  selector: 'app-wizard-loader',
  templateUrl: './wizard-loader.component.html',
  styleUrls: ['./wizard-loader.component.scss'],
})
export class WizardLoaderComponent extends ComponentCanDeactivate {
  public wizardConfig: Request = null;
  public redirectUrl: string;
  public templateTypes = TemplateTypes;
  public baseUrl = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private configProvider: ConfigProvider,
    private lockService: LockService
  ) {
    super();
    this.baseUrl = this.configProvider.AppSetting?.uriBase?.apiBaseUrl;
    this.wizardConfig =
      this.router.getCurrentNavigation()?.extras?.state ??
      this.route.snapshot.data?.wizardConfig ??
      null;
    this.redirectUrl = this.route.snapshot.data?.redirectUrl;
    if (!this.wizardConfig) {
      this.redirect();
    }
  }
  public canDeactivate(nextState?: RouterStateSnapshot): boolean {
    return !this.lockService.peek('navigation');
  }

  public redirect() {
    this.lockService.release('navigation');
    this.router.navigate([this.redirectUrl], { relativeTo: this.route });
  }
}
